import {client} from './services/webservices-client'

export const recharges = {
    namespaced: true,
    state: {
        recharges: undefined,
        recharge:undefined
    },
    mutations: {
        SET_RECHARGES(state, recharges) {
            state.recharges = recharges
        },
        SET_RECHARGE(state, recharges) {
            state.recharge = recharges
        },

    },
    actions: {
        getRecharges({commit}, data) {
            return new Promise((resolve, reject) => {
                client({
                    method: 'get',
                    url: '/v1/recharges/get/'+data.type+'/'+data.id,
                }).then((response) => {
                        commit('SET_RECHARGES', response.data.recharges);
                    }).catch((error) => {
                        reject(error);
                    })
            })

        },
        setRecharge({commit}, data) {
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: '/v1/recharges/perform',
                    data: data,
                }).then((response) => {
                        commit('SET_RECHARGE', response.data.recharge);
                        resolve(response)
                    })
                    .catch((error) => {
                      console.log("errorrecharge2",error);
                        reject(error);
                    })
            });
        }
    },
    getters: {
        getRecharges: state => {
            return state.recharges
        }

    }
};
